<template>
  <div id="glAccount-create" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <v-row align="center" class="mb-4">
              <v-col cols="8" class="d-flex align-center">
                <HeaderDividerBlock headerText="Create GL Account" />
              </v-col>
              <v-col cols="4" class="d-flex justify-end">
                <v-btn
                  color="#43A047"
                  dark
                  :to="{ path: '/gl-account/sub-headers/create' }"
                  class="ml-2"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Create Sub Header
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">GL Account Type</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.gl_account_type_id"
                  required
                  clearable
                  placeholder="GL Account Type"
                  :items="AccountTypes"
                  item-text="title"
                  item-value="id"
                  @change="onAccountTypeChange(form.gl_account_type_id)"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Sub Header</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.gl_sub_header_id"
                  required
                  clearable
                  placeholder="Sub Header Name"
                  :items="subHeaders"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">GL Account Title</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.title"
                  required
                  clearable
                  placeholder="GL Account Title"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Description</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.description"
                  required
                  clearable
                  placeholder="Description"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Sort Order</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.sort_order"
                  required
                  clearable
                  placeholder="Sort Order"
                  type="number"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.branch_id"
                  required
                  clearable
                  placeholder="Branch"
                  :items="Branches"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <!-- <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Status</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.status"
                  required
                  clearable
                  label="Status"
                ></v-text-field>
              </v-col> -->
            </v-row>

            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('gl_account.create')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                  >
                    Create GL Account
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { GlAccountService } from "@/services/glAccount-service.js";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreateGlAccount",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    form: {
      title: "",
      description: "",
      sort_order: "",
      gl_sub_header_id: "",
      branch_id: "",
      status: "ACTIVE",
      gl_account_type_id: "",
    },
    MainAccounts: [],
    Branches: [],
    AccountTypes: [],
    subHeaders: [],
  }),
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    this.fetchMainGlAccounts();
    this.fetchBranches();
    this.fetchAccountTypes();
  },
  methods: {
    async onAccountTypeChange(id) {
      try {
        const subHeaders = await GlAccountService.getSubHeaders(id);
        this.subHeaders = subHeaders.data.data;
      } catch (error) {
        this.errors = checkError.errorFormatting(error.response.data);
      }
    },
    async submit() {
      this.loading = true;
      this.errors = null;
      try {
        const response = await GlAccountService.createGlAccount(this.form);
        this.succesMsg = response.message;
        this.snackbar = true;
        this.resetForm();
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        title: "",
        sort_order: "",
        gl_account_type_id: "",
        description: "",
        branch_id: "",
        gl_sub_header_id: "",
      };
    },
    async fetchMainGlAccounts() {
      try {
        const accounts = await GlAccountService.getMainAccounts();
        this.MainAccounts = accounts.data;
      } catch (error) {
        this.errors = checkError.errorFormatting(error.response.data);
      }
    },
    async fetchBranches() {
      try {
        const branches = await GlAccountService.getBranches();
        this.Branches = branches.data;
      } catch (error) {
        this.errors = checkError.errorFormatting(error.response.data);
      }
    },
    async fetchAccountTypes() {
      try {
        const accountTypes = await GlAccountService.getAccountTypes();
        this.AccountTypes = accountTypes.data;
      } catch (error) {
        this.errors = checkError.errorFormatting(error.response.data);
      }
    },
  },
};
</script>
